<template>
  <div class="pl-4 pt-4">
    <h1>Chat Creator</h1>
    <hr />
    <v-layout wrap>
      <v-flex xs1 pr-4>
        <v-text-field v-model="user1_id" label="user1_id"></v-text-field>
      </v-flex>
      <v-flex xs1 pr-4>
        <v-text-field v-model="user2_id" label="user2_id"></v-text-field>
      </v-flex>
      <v-flex xs1>
        <v-btn color="primary" @click="create()">create</v-btn>
      </v-flex>
      <v-flex xs2>
        <v-progress-circular
          v-show="submitting"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-flex>
    </v-layout>
    <div :style="{ color: color }">
      {{ message }}
    </div>
  </div>
</template>

<script>
const BLACK = 'black';
const RED = 'red';

export default {
  data() {
    return {
      user1_id: null,
      user2_id: null,
      submitting: false,
      color: BLACK,
      message: '',
    };
  },

  methods: {
    async create() {
      let user1 = parseInt(this.user1_id);
      let user2 = parseInt(this.user2_id);
      if (!user1) return this.userNan('user1');
      if (!user2) return this.userNan('user2');
      this.submitting = true;
      axios
        .post(`/admin/chats/create/${user1}/${user2}`)
        .then((res) => this.showResult(res.data))
        .catch((e) => this.showError(e.response ? e.response.data : ''));
    },
    userNan(username) {
      this.showError(`${username}'s id is invalid!`);
    },
    showResult(message) {
      this.submitting = false;
      this.message = message;
      this.color = BLACK;
    },
    showError(error) {
      this.submitting = false;
      this.message = error;
      this.color = RED;
    },
  },
};
</script>
